import '../../assets/styles/login.css';
import { useState } from 'react';
import { validateOTP } from '../../assets/constants/global_apis';
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { setLoginUser } from '../../common_functions/store';


export default function UpdatePassword({ triggerAlert, setCurrentPage }) {
  const [reqData, setReqData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch()


  const handleChange = (e) => {
    const { name, value } = e.target;
    if(/^\d*$/.test(value)){
        setReqData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    let email = localStorage.getItem('email');
    if (!email && email.length == 0) {
      triggerAlert('Error', 'User not found');
      navigate('/login');
    } else if (reqData.otp.length != 6) {
      triggerAlert('Error', 'Ivalid OTP');
    } else {
      validateOTP({ 'email': email, 'otp': reqData.otp }).then((response) => {
        triggerAlert('Success', 'OTP Validated successfully');
        dispatch(setLoginUser({
          authToken: response?.token,
          role: response?.role,
          userName: response?.username,
          init_password: response?.init_password == 'true' ? true : false
        }));
        localStorage.setItem('authToken', response?.token);
        localStorage.setItem('role', response?.role);
        localStorage.setItem('username', response?.username);
        localStorage.setItem('user_id', response?.id);
        localStorage.setItem('init_password', response?.init_password);
        setCurrentPage('/reset-password');
        navigate('/reset-password');
      }).catch((err) => {
        triggerAlert('Error', err.message);
      });
    }
  };



  return (
    <><form role="form" className="text-start"
      onSubmit={handleSubmit}
    >
      <div>
        <label>One Time Password</label>
        <div className="mb-3">
          <input
            type="text"
            name='otp'
            className="form-control"
            placeholder="OTP"
            aria-label="OTP"
            value={reqData?.otp}
            maxLength={6}
            minLength={6}
            onChange={handleChange}
            required
          />
        </div>
      </div>
      <div className="text-center">
        <button
          type="submit"
          className="btn bg-gradient-info w-100 mt-4 mb-0"
        >
          Validate OTP
        </button>
      </div>
    </form>
    </>
  );
}
